import { render, staticRenderFns } from "./IntelligencePeople.vue?vue&type=template&id=10cac5b2&scoped=true"
import script from "./IntelligencePeople.vue?vue&type=script&lang=js"
export * from "./IntelligencePeople.vue?vue&type=script&lang=js"
import style0 from "./IntelligencePeople.vue?vue&type=style&index=0&id=10cac5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cac5b2",
  null
  
)

export default component.exports